// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invite-field{
    width: 215px !important;
}

.roles{
    margin-left: -8px 
}

.hover-div{
    cursor: pointer;
    position: relative;
}

#manager-dropdown{
    width:245px !important;
}

.DarkTheme #manager-dropdown{
    width:245px !important;
}

.rolesDropdownCard{
    position: absolute;
    /* bottom: 0; */
    /* top: 255px; */
    font-size: 18px;
    /* left: 9px; */
    z-index: 9999999;
    width: 11rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 14px;
    /* border: 1px solid var(--foundation-neutral-neutral-400, #E3E9F4); */
    background: #FFF;
    box-shadow: 10px 14px 74px 0px var(--primary-opactiy-10);
}

.DarkTheme .rolesDropdownCard {
    position: absolute;
    /* bottom: 0; */
    /* top: 255px; */
    font-size: 18px;
    /* left: 9px; */
    z-index: 9999999;
    width: 11rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 14px;
    background: var(--main-neutral-dark-theme-neutral-dark-theme-700, #343535) !important;
    box-shadow: 10px 14px 74px 0px var(--primary-opactiy-10);
}

.DarkTheme .number-span{
    color: black;
}

.role-tooltip{
    position: absolute;
    background: #FFF;
    color: var(--text-high-emphasis, #090826);
    gap: 8px;
    font-family: Inter;
    font-size: 0.8rem;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
    padding: 5px;
    width: max-content;
    border-radius: 4px;
    top: 35px;
    left: 68px;
    transform: translateX(-50%);
    z-index: 2000000 !important;
}

.number-span{
    height: 36px;
    width: 36px;
    margin-top: 8px;
    margin-left: -8px;
}

.role-avatar{
    border: 3px solid #E3E9F4;
}

.loading-img{
    height:250px;
    width:300px;  
    margin-top:100px; 
}

.invite-text {
    font-weight:600;
    font-size:18px;
    margin-top:50px;
}

.loading-div{
    height: 500px;
    width: 500px;
    display: flex;
    align-items: center;   
}

#custom-multiselect{
    border: 1px solid #ccc!important;
    border-radius: 4px !important;
    width: 215px;
}

.generate-password {
    min-width: 252px;
    min-height: 22px !important;
    flex: 1 1;
    padding: 7px;
    box-sizing: border-box;
    border: 1px solid #ccc;
    border-radius: 5px;
    margin-right: 12px;
}

.rdt_TableRow{
    min-height: 60px !important;
}

.rdt_TableHeadRow{
    background: #E3E9F4 !important;
    /* //border-radius: 93px; */
    border-bottom-width: none !important;
    border-bottom-color: none!important;
    border-bottom-style: none!important; 
    min-height: 30px !important;
}

.rdt_TableBody{
    overflow: scroll;
    height: calc(100vh - 230px);
}

.toggle-password {
    position: absolute;
    right: 20px;
    top: 13px;
    cursor: pointer;
}

.email-field{
    height: 22px;
}

/* //editUser Popup */

input[type='checkbox']{
    width: 14px !important;
    height: 14px !important;
    margin-right: 10px;
    margin-top: 5px;
    -o-appearance: none;
    appearance: none;
    box-shadow: none;
    font-size: 0.8em;
    text-align: center;
    line-height: 1.20em;
    background: white;
    border:2px solid black;
  }
  
  input[type='checkbox']:checked:after {
    content: '✔';
    color: white;
    background: var(--primary);
  }

.edit-user {
    background: white;
    height: -moz-fit-content;
    height: fit-content;
    width: 595px;
}

.input-field{
    width:250px;
}

.toggle-bg{
    position: relative;
    display: inline-block;
    width: 180px;
    height: 31px;
}

.toggle-slider{
    position: absolute;
    content: "";
    height: 31px;
    width: 95px;
    left: -17px;
    top: 0px;
    background-color: #9CA2AB;
    transition: 0.4s;
}

input[type=checkbox]:checked + label:before{
    background-color: var(--primary) !important;
}

.input-errors{
    color: var(--Error-error-button-enabled, #FF6969);
    font-size: 12px;
    font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/kz-usermanagement/css/userman.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;AAC3B;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,sEAAsE;IACtE,gBAAgB;IAChB,wDAAwD;AAC5D;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,qFAAqF;IACrF,wDAAwD;AAC5D;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yCAAyC;IACzC,QAAQ;IACR,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,SAAS;IACT,YAAY;IACZ,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;IAC9B,2BAA2B;IAC3B,oCAAoC;IACpC,mCAAmC;IACnC,mCAAmC;IACnC,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA,qBAAqB;;AAErB;IACI,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,0BAA0B;EAC5B;;AAEF;IACI,iBAAiB;IACjB,wBAAmB;IAAnB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,WAAW;IACX,QAAQ;IACR,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,iDAAiD;IACjD,eAAe;IACf,gBAAgB;AACpB","sourcesContent":[".invite-field{\n    width: 215px !important;\n}\n\n.roles{\n    margin-left: -8px \n}\n\n.hover-div{\n    cursor: pointer;\n    position: relative;\n}\n\n#manager-dropdown{\n    width:245px !important;\n}\n\n.DarkTheme #manager-dropdown{\n    width:245px !important;\n}\n\n.rolesDropdownCard{\n    position: absolute;\n    /* bottom: 0; */\n    /* top: 255px; */\n    font-size: 18px;\n    /* left: 9px; */\n    z-index: 9999999;\n    width: 11rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    border-radius: 14px;\n    /* border: 1px solid var(--foundation-neutral-neutral-400, #E3E9F4); */\n    background: #FFF;\n    box-shadow: 10px 14px 74px 0px var(--primary-opactiy-10);\n}\n\n.DarkTheme .rolesDropdownCard {\n    position: absolute;\n    /* bottom: 0; */\n    /* top: 255px; */\n    font-size: 18px;\n    /* left: 9px; */\n    z-index: 9999999;\n    width: 11rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    border-radius: 14px;\n    background: var(--main-neutral-dark-theme-neutral-dark-theme-700, #343535) !important;\n    box-shadow: 10px 14px 74px 0px var(--primary-opactiy-10);\n}\n\n.DarkTheme .number-span{\n    color: black;\n}\n\n.role-tooltip{\n    position: absolute;\n    background: #FFF;\n    color: var(--text-high-emphasis, #090826);\n    gap: 8px;\n    font-family: Inter;\n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 130%;\n    padding: 5px;\n    width: max-content;\n    border-radius: 4px;\n    top: 35px;\n    left: 68px;\n    transform: translateX(-50%);\n    z-index: 2000000 !important;\n}\n\n.number-span{\n    height: 36px;\n    width: 36px;\n    margin-top: 8px;\n    margin-left: -8px;\n}\n\n.role-avatar{\n    border: 3px solid #E3E9F4;\n}\n\n.loading-img{\n    height:250px;\n    width:300px;  \n    margin-top:100px; \n}\n\n.invite-text {\n    font-weight:600;\n    font-size:18px;\n    margin-top:50px;\n}\n\n.loading-div{\n    height: 500px;\n    width: 500px;\n    display: flex;\n    align-items: center;   \n}\n\n#custom-multiselect{\n    border: 1px solid #ccc!important;\n    border-radius: 4px !important;\n    width: 215px;\n}\n\n.generate-password {\n    min-width: 252px;\n    min-height: 22px !important;\n    flex: 1 1;\n    padding: 7px;\n    box-sizing: border-box;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    margin-right: 12px;\n}\n\n.rdt_TableRow{\n    min-height: 60px !important;\n}\n\n.rdt_TableHeadRow{\n    background: #E3E9F4 !important;\n    /* //border-radius: 93px; */\n    border-bottom-width: none !important;\n    border-bottom-color: none!important;\n    border-bottom-style: none!important; \n    min-height: 30px !important;\n}\n\n.rdt_TableBody{\n    overflow: scroll;\n    height: calc(100vh - 230px);\n}\n\n.toggle-password {\n    position: absolute;\n    right: 20px;\n    top: 13px;\n    cursor: pointer;\n}\n\n.email-field{\n    height: 22px;\n}\n\n/* //editUser Popup */\n\ninput[type='checkbox']{\n    width: 14px !important;\n    height: 14px !important;\n    margin-right: 10px;\n    margin-top: 5px;\n    -o-appearance: none;\n    appearance: none;\n    box-shadow: none;\n    font-size: 0.8em;\n    text-align: center;\n    line-height: 1.20em;\n    background: white;\n    border:2px solid black;\n  }\n  \n  input[type='checkbox']:checked:after {\n    content: '✔';\n    color: white;\n    background: var(--primary);\n  }\n\n.edit-user {\n    background: white;\n    height: fit-content;\n    width: 595px;\n}\n\n.input-field{\n    width:250px;\n}\n\n.toggle-bg{\n    position: relative;\n    display: inline-block;\n    width: 180px;\n    height: 31px;\n}\n\n.toggle-slider{\n    position: absolute;\n    content: \"\";\n    height: 31px;\n    width: 95px;\n    left: -17px;\n    top: 0px;\n    background-color: #9CA2AB;\n    transition: 0.4s;\n}\n\ninput[type=checkbox]:checked + label:before{\n    background-color: var(--primary) !important;\n}\n\n.input-errors{\n    color: var(--Error-error-button-enabled, #FF6969);\n    font-size: 12px;\n    font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
